import axios from "axios";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

const AddEmail = (props) => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [reqnum, setReqnum] = useState("");
  const [pin, setPin] = useState("");
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);

  const renderErrors = () => {
    return (
      errors &&
      errors.map((error, index) => (
        <div key={index} className="alert alert-danger">
          {String(error)}
        </div>
      ))
    );
  };

  const renderEmail = () => (
    <div className="form-group">
      <label htmlFor="email">{t("email")}</label>
      <input
        id="email"
        name="email"
        type="email"
        className="form-control"
        placeholder={t("email_placeholder")}
        value={email}
        onChange={(event) => {
          setErrors();
          setEmail(event.target.value);
        }}
        required
      />
    </div>
  );

  const renderReqnum = () => (
    <div className="form-group">
      <label htmlFor="reqnum">{t("reqnum")}</label>
      <input
        id="reqnum"
        name="reqnum"
        type="text"
        className="form-control"
        placeholder={t("reqnum_placeholder")}
        value={reqnum}
        onChange={(event) => {
          setErrors();
          setReqnum(event.target.value);
        }}
        required
      />
    </div>
  );

  const renderPin = () => (
    <div className="form-group">
      <label htmlFor="pin">{t("pin")}</label>
      <input
        id="pin"
        name="pin"
        type="text"
        className="form-control"
        placeholder={t("pin_placeholder")}
        value={pin}
        onChange={(event) => {
          setErrors();
          setPin(event.target.value);
        }}
        required
      />
    </div>
  );

  const getHost = () =>
    process.env.NODE_ENV !== "production"
      ? "http://localhost:3000/"
      : "https://bg-citizenship-bot-ohio.onrender.com/";

  return (
    <div className="row">
      <form
        className="col-sm-6"
        onSubmit={async (event) => {
          setLoading(true);
          event.preventDefault();
          try {
            await axios.post(`${getHost()}emailee/create/`, {
              email,
              reqnum,
              pin,
              lang: i18n.language,
            });
            props.history.push("/pending/");
          } catch (error) {
            console.error(error);
            const { errors: _errors } = error.response.data;
            setErrors(_errors);
            setLoading(false);
          }
        }}
      >
        {renderErrors()}
        {renderEmail()}
        {renderReqnum()}
        {renderPin()}
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading && (
            <i className="fas fa-spinner fa-spin mr-2" aria-hidden="true"></i>
          )}
          {t("continue")}
        </button>
      </form>
    </div>
  );
};

export default withRouter(AddEmail);
